import { render, staticRenderFns } from "./MultiSelectContentType.vue?vue&type=template&id=2ce45764"
import script from "./MultiSelectContentType.vue?vue&type=script&lang=js"
export * from "./MultiSelectContentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports